import "./index.css";
import { AuthenticationProvider } from "authentication/AuthenticationContext";
import { RecipeProvider } from "components/recipe/providers/RecipeProvider";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthenticationProvider>
      <RecipeProvider>
        <App />
      </RecipeProvider>
    </AuthenticationProvider>
  </React.StrictMode>,
);
